var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 83,
    viewBox: "0 0 111 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_581_23507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9038 11.9822C31.6097 10.7596 30.1825 8.61404 27.716 7.18999C25.2496 5.76595 22.6779 5.60268 21.972 6.8253C21.2661 8.04793 22.6933 10.1935 25.1597 11.6175C27.6262 13.0416 30.1979 13.2048 30.9038 11.9822Z",
    fill: "#FFD29E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_581_23507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.376 11.2376C42.9675 10.4777 42.1002 8.81323 40.4388 7.51984C38.7774 6.22645 36.951 5.79395 36.3594 6.55382C35.7679 7.31369 36.6352 8.97819 38.2966 10.2716C39.958 11.565 41.7844 11.9975 42.376 11.2376Z",
    fill: "#FFD29E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_581_23507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5111 15.3212C53.0193 14.7685 52.3697 13.3443 51.0602 12.14C49.7506 10.9358 48.277 10.4076 47.7688 10.9603C47.2606 11.5129 47.9102 12.9372 49.2198 14.1414C50.5293 15.3456 52.0029 15.8738 52.5111 15.3212Z",
    fill: "#FFD29E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_581_23507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5967 21.9896C22.3176 19.7442 19.7969 16.9268 15.9663 15.6969C12.1358 14.467 8.4461 15.2903 7.72512 17.5358C7.00414 19.7812 9.52493 22.5986 13.3554 23.8285C17.186 25.0584 20.8757 24.2351 21.5967 21.9896Z",
    fill: "#FFD29E"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_581_23507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1614 42.6582C22.6925 38.9994 18.4803 36.5245 13.753 37.1302C9.02578 37.7359 5.57364 41.193 6.04247 44.8518C6.5113 48.5105 10.7236 50.9855 15.4508 50.3798C20.1781 49.774 23.6302 46.317 23.1614 42.6582Z",
    fill: "#FFD29E"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_581_23507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.6254 65.9721C73.0016 65.4355 73.2976 62.8987 72.2866 60.3059C71.2756 57.7132 69.3405 56.0464 67.9642 56.583C66.588 57.1197 66.292 59.6565 67.303 62.2492C68.314 64.842 70.2492 66.5088 71.6254 65.9721Z",
    fill: "#FFD29E"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_581_23507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8576 75.4057C35.3488 76.6216 39.4302 74.0148 40.9735 69.5833C42.5168 65.1518 40.9377 60.5737 37.4465 59.3578C33.9552 58.1419 29.8739 60.7487 28.3305 65.1802C26.7872 69.6117 28.3663 74.1898 31.8576 75.4057Z",
    fill: "#FFD29E"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_581_23507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9622 78.0644C61.2947 77.7158 62.7211 74.3254 62.1482 70.4917C61.5752 66.658 59.2199 63.8328 56.8874 64.1813C54.5549 64.5299 53.1285 67.9203 53.7014 71.754C54.2744 75.5877 56.6297 78.413 58.9622 78.0644Z",
    fill: "#FFD29E"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_581_23507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.583 24.2969H38.6557L41.8994 36.1824L44.9724 24.2969H51.6307L55.187 36.1897L57.606 24.2969H64.9471L59.1425 49.8835H52.4842L48.5436 34.8499L43.7773 49.8835H36.0948L30.9731 27.9287H28.583V24.2969Z",
    fill: "#FFD29E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8049 49.7928L66.7236 24.2969H85.7318L84.1194 31.8593L72.4489 31.7051L71.9955 33.4886L83.5282 33.6328L81.9981 40.1356L70.5573 39.9966L69.9662 42.083L88.7444 42.0482L86.9079 49.7928H60.8049Z",
    fill: "#FFD29E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4324 40.1698L87.7806 24.2963L108.026 23.8132L109.364 22.5859L110.513 23.781H111L109.399 31.4087L92.6994 31.3832L92.1125 33.6011L108.934 33.6457L105.764 49.7922H88.3496L90.1139 41.964L100.201 41.8116L100.675 39.9787L84.4324 40.1698Z",
    fill: "#FFD29E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_581_23507",
    x: 15.7915,
    y: 0.0078125,
    width: 19.2927,
    height: 16.7969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_581_23507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_581_23507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_581_23507",
    x: 30.1736,
    y: 0.179688,
    width: 16.3882,
    height: 15.4297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_581_23507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_581_23507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_581_23507",
    x: 41.5959,
    y: 4.74219,
    width: 15.0881,
    height: 14.7969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_581_23507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_581_23507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_581_23507",
    x: 1.60205,
    y: 9.125,
    width: 24.1177,
    height: 19.2734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_581_23507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_581_23507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_581_23507",
    x: -0.000244141,
    y: 31.0391,
    width: 27.2043,
    height: 23.4297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_581_23507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_581_23507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_581_23507",
    x: 60.7026,
    y: 50.4844,
    width: 16.1843,
    height: 19.5859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_581_23507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_581_23507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_581_23507",
    x: 21.7388,
    y: 53.0625,
    width: 23.8267,
    height: 26.6406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_581_23507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_581_23507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_581_23507",
    x: 47.575,
    y: 58.1484,
    width: 18.6997,
    height: 23.9453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_581_23507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_581_23507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_581_23507",
    x: 20.583,
    y: 17.5859,
    width: 90.417,
    height: 35.2969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_581_23507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_581_23507",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.49671dad2211b095730e416be5a10f9a.svg";
export { ForwardRef as ReactComponent };